import { DONATION_ROUTES, ROUTES } from '@/constants/routes';

const CHANNEL_TALK_SECTIONS = [ROUTES.MY.pathname, DONATION_ROUTES.MY.pathname];

export const isChannelTalkPath = (pathname: string | null) =>
  CHANNEL_TALK_SECTIONS.some(
    (section) => pathname === section || !!pathname?.startsWith(`${section}/`),
  );
